var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-textarea',_vm._b({staticClass:"input_color",attrs:{"id":"textarea","value":_vm.text},on:{"input":_vm.updateValue}},'b-form-textarea',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }